import { IGlobalState } from '../states/GlobalState';
import { Principal } from '../models/principal';
import { GetConfiguration } from "../utils/config";
import { getHeaders, handleErrors } from './common';
import Auth, { AuthDataType, IAuth} from '../types/auth';
import { User } from 'oidc-client';

export const getIdentity = (ip: string, authData: AuthDataType, user: User) => {
    // let fake_prov = (prov === undefined || prov === null) ? "44" : prov;
    
    console.log('Sono in get identity con username: ' + authData.user);
    const url = `${GetConfiguration().api_url}/auth/identity`
    console.log('Get Identity', url)
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getIdentity ("${authData.user}") -> letti ${json.length} utenti`);
            console.log('getIdentity recuperato json: ' + JSON.stringify(json));
            const rv = (json as Principal);
            console.log('getIdentity recuperato principal: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getIdentity error:', error);
            throw error;
        });
}

export function getHeadersForSSO(ip: string, user: User): Headers {

    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('IP', ip);
    
    headers.append("Authorization", `Bearer ${user.access_token}`);
    return headers;
}

export function handleErrorsForSSO(response: any, auth?: IAuth) {   
    if (!response.ok) {
        if (response.status === 401) //unauthorzied
        {
            console.log('Error console HandleError unauthorized ');
            if (auth)
                auth.userManager.signoutRedirect();
        } else {        
            console.log('handleErrors', response)
            throw Error(response.statusText);
        }
    }
    return response;
}

export const getIdentityFromSSO = (ip: string, authData: AuthDataType, user: User) => {
    // let fake_prov = (prov === undefined || prov === null) ? "44" : prov;    
    console.log('Sono in get identitySSO con username: ' + authData.user);
    const url = `${GetConfiguration().api_url}/auth/identity/${authData.user}`
    console.log('Get IdentitySSO', url)
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)    
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getIdentitySSO ("${authData.user}") -> letti ${json.length} utenti`);
            // console.log(`getIdentitySSO ("${authData.user}") -> recuperato ${json} utente`);
            // console.log('getIdentitySSO recuperato json: ' + JSON.stringify(json));
            const rv = (json as Principal);
            console.log('getIdentitySSO recuperato rv: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getIdentitySSO error:', error);
            throw error;
        });
}

export const getIdentityFromSSOByAlias = (ip: string, authData: AuthDataType, user: User) => {
    // let fake_prov = (prov === undefined || prov === null) ? "44" : prov;    
    console.log('Sono in get identitySSO con username: ' + authData.user);
    console.log('Sono in get identitySSO con alias: ' + authData.alias);
    const url = `${GetConfiguration().api_url}/auth/identity/${authData.alias}`
    console.log('Get IdentitySSO', url)
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)    
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getIdentitySSO ("${authData.alias}") -> letti ${json.length} utenti`);
            // console.log(`getIdentitySSO ("${authData.user}") -> recuperato ${json} utente`);
            // console.log('getIdentitySSO recuperato json: ' + JSON.stringify(json));
            const rv = (json as Principal);
            console.log('getIdentitySSO recuperato rv: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getIdentitySSO error:', error);
            throw error;
        });
}
